import { uiConfig } from '@/config';
import { cn } from '@/libs';

import { Input } from '../inputs';
import { FormValidation, FormFieldType } from '../../typings';
import type { LoginFormField } from '../../typings';
import { config } from '../../config';
import { FormFieldAlertMessage } from './FormFieldAlertMessage';

interface LoginFieldPresenterProps {
  field: LoginFormField;
}

const containerClasses = cn(
  'grid',
  'gap-y-[20px]',
  'grid-cols-1',
  uiConfig.grid.maxColumnsSpanClass,
);

export const LoginFieldPresenter: React.FC<LoginFieldPresenterProps> = ({
  field,
}) => {
  const isRequired = field.field.validations?.some(
    v => v.type === FormValidation.Required,
  );

  return (
    <div className={containerClasses}>
      {field.alertMessage && (
        <FormFieldAlertMessage alertMessage={field.alertMessage} />
      )}
      <Input.Text
        label="Login Question Type"
        name={`${field.field.fieldId}${config.loginFieldQuestionTypeSuffix}`}
        type="hidden"
      />
      {field.field.type === FormFieldType.Input ? (
        <Input.Text
          type={field.field.inputType}
          label={field.field.label}
          name={field.field.fieldId}
          placeholder={field.field.placeholder}
          required={isRequired}
        />
      ) : (
        <Input.Date
          label={field.field.label}
          name={field.field.fieldId}
          placeholder={field.field.placeholder}
          required={isRequired}
        />
      )}
    </div>
  );
};
